import apiService from '../apiService';

const TrackingService = {
  getLogs: () => apiService.get('/logs'),

  trackAction(actionType, details = {}) {
    const userData = JSON.parse(localStorage.getItem("user")) || {}
    const trackingData = {
      userId: userData.firstName+' '+userData.lastName || "guest",
      action: actionType,
      timestampFront: new Date().toISOString(),
      page: window.location.pathname,
      pageTitle: document.title,
      buttonId: details.buttonId || "no-id",
      browser: navigator.userAgent,
      device: /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
      referrer: document.referrer,
      sessionId: localStorage.getItem("sessionId") || "unknown"      
    };

    // console.log('trackingData ' + JSON.stringify(trackingData))
  
    apiService.post('/logs/track', trackingData)
      .then(() => console.log("Tracked:", trackingData))
      .catch(error => console.error("Tracking error:", error));
  }
};

export default TrackingService ;
